<template>
  <el-dialog
    title="表头显示和顺序调整"
    class="radish-dia"
    top="70px"
    width="400px"
    :modal="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-row>
      <el-col :span="12" class="head-sort-item">
        <div>勾选显示的表头：</div>
        <div><el-checkbox v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox></div>
        <div class="head-checklist">
          <div v-for="(v, k) in heads" :key="v.label + k">
            <label><input v-model="v.visible" type="checkbox" /> {{ v.label }} </label>
          </div>
        </div>
      </el-col>
      <el-col :span="12" class="head-sort-item">
        <div>拖拽调整顺序：</div>
        <SortableList v-model="items" lock-axis="y">
          <SortableItem v-for="(item, index) in items" :key="index" :index="index" :item="item" />
        </SortableList>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { ContainerMixin, ElementMixin } from 'vue-slicksort'

const SortableList = {
  mixins: [ContainerMixin],
  render: function(createElement) {
    return createElement('div', { attrs: { class: 'sortlist' } }, this.$slots.default)
  },
}
const SortableItem = {
  mixins: [ElementMixin],
  props: ['item'],
  render: function(createElement) {
    return createElement('div', { attrs: { class: 'sortlist-item' } }, this.item)
  },
}
export default {
  components: {
    SortableItem,
    SortableList,
  },
  data: function() {
    return {
      dialogVisible: false,
      storageName: '',
      heads: [],
      items: [],
      onConfirm: function() {},
      checkAll: true,
    }
  },
  watch: {
    heads: {
      handler: function(newVal) {
        const item = newVal.filter(head => head.visible)
        this.items = item.map(h => h.label)
        this.checkAll = this.heads.every(h => h && h.visible)
      },
      deep: true,
    },
  },
  methods: {
    show: function(param) {
      const { heads, storageName, onConfirm } = param
      this.heads = heads
      this.storageName = storageName
      this.onConfirm = onConfirm
      this.dialogVisible = true
    },
    handleConfirm: function() {
      const dt = {}
      for (const h of this.heads) {
        dt[h.label] = !h.visible
      }
      localStorage[this.storageName] = JSON.stringify(dt)
      const sortDt = {}
      this.items.forEach((h, k) => {
        sortDt[h] = k + 1
      })
      localStorage[`${this.storageName  }_sort`] = JSON.stringify(sortDt)
      this.onConfirm()
      this.dialogVisible = false
    },
    handleCheckAllChange(val) {
      this.heads.map(head => (head.visible = val))
    },
  },
}
</script>
<style>
.head-sort-item {
  border: 1px solid #efefef;
  padding: 5px 0 5px 5px;
}
.sortlist,
.head-checklist {
  background-color: #f3f3f3;
  border: 1px solid #efefef;
  max-height: 60vh;
  overflow-y: auto;
}
.sortlist-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
  padding: 10px 20px;
  background-color: #fff;
  border-bottom: 1px solid #efefef;
  box-sizing: border-box;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  color: #333;
  font-weight: 400;
  cursor: pointer;
  z-index: 9999;
}
</style>
